{
  "visHjelpeskuffAriaLabel": "Mana deike Veahkki dása",
  "unknownError": "Juoga geavai boastut",
  "unknownErrorAction": "Luđe siiddu ođđasit!",
  "pendingChangesHeader": "Leat rievdadusat mat eai leat vurkejuvvon",
  "pendingChangesClose": "Sihko rievdadusaid",
  "pendingChangesConfirm": "Joatkke rievdadeami",
  "pendingChangesDescription": "Jus guođát siiddu, de massát buot rievdadusaid maid leat dahkan.",
  "languageChanged": "Giella rievdaduvvon davvisámegillii",
  "breadCrumb_Forsiden": "Ovdasiidu",
  "pageNotFoundHeader": "Dán siidu ii oro leat áibbas dearvvaš",
  "pageNotFoundDescription": "Oza URL-čujuhusas čállinmeattáhusa, dahje mana ovdasiidui.",
  "pageNotFoundToStart": "Mana ovdasiidui",
  "sharing_Status_Delt_Med_Barnet": "Juogaduvvon mánáin",
  "sharing_Status_Bare_Synlig_For_Deg": "Dán oainnát dušše don",
  "word_explanation_open": "Raba sátnečilgehusa",
  "word_explanation_close": "Gidde sátnečilgehusa",
  "word_explanation_search_description": "Jus oainnát sániid dahje dadjanvugiid maid it ipmir, de sáhtát dákko ohcat. Fuomáš ahte bohtosat čájehuvvojit dušše dárogillii.",
  "word_explanation_search_input_label": "Oza",
  "word_explanation_search_submit_button": "Oza",
  "word_explanation_search_source_prefix": "Gáldu:",
  "language_norwegian": "Norsk",
  "language_english": "English",
  "language_sami": "Sámi",
  "language_nynorsk": "Nynorsk",
  "language_lithuanian": "Lietuviškai",
  "language_polish": "Polski",
  "language_russian": "Русский",
  "language_romanian": "Română",
  "visHjelpeskuffTekst": "Eambbo veahkki",
  "breadcrumb_arialabel": "Láidestančuoggát",
  "language_picker_trigger_text": "Språk/Language",
  "language_ukrainian": "Українська",
  "language_french": "Français",
  "word_explanation_search_container_label": "Sátnečilgehusat",
  "driftspanel_aria_label": "Doaibmadieđáhusat",
  "sharing_Status_Skjult_For_Barnet": "Skjult for barnet",
  "sharing_Status_Skjult_For_Fullmektig": "Skjult for fullmektig"
}
